import { MaterialTopTabBarProps } from '@react-navigation/material-top-tabs';
import React, { FC } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';
import StyledIcon from '../StyledIcon';

const HomeTopTabBar: FC<MaterialTopTabBarProps> = (props) => {

    const handlePress = (routeName: string) => {
        try {
            props.navigation.navigate(routeName)
        } catch (e) {
            console.log(e)
        }
    }

    const iconName = (routeName: string): string => {
        switch (routeName) {
            case 'Category':
                return 'ios-grid-outline';

            case 'Manufacturer':
                return 'circle';

            default:
                return 'star';
        }
    }
    const iconLib = (routeName: string): any => {
        switch (routeName) {
            case 'Category':
                return 'Ionicons';

            case 'Manufacturer':
                return 'Feather';

            default:
                return 'Feather';
        }
    }

    return <>
        <View style={[
            props.style,
            props.contentContainerStyle,
            styles.containerStyle
        ]}>
            {
                props.state.routes.map((route) => <View
                    key={`${route.key}`}
                    style={[
                        props.tabStyle,
                        styles.tabStyle
                    ]}
                >
                    <TouchableOpacity
                        activeOpacity={1}
                        style={[
                            styles.tabButtonStyle,
                            props.state.routes[props.state.index].key === route.key && styles.tabButtonStyleActive,
                        ]}
                        onPress={() => handlePress(route.name)}>
                        {/* <StyledIcon
                            iconName={iconName(route.name)}
                            iconLibrary={iconLib(route.name)}

                            iconColor={props.state.routes[props.state.index].key === route.key ? Colors.tintColor : Colors.darkTextColor}
                            style={[
                                props.iconStyle
                            ]}
                        /> */}
                        <Text
                            style={[
                                styles.tabTextStyle,
                                props.state.routes[props.state.index].key === route.key && styles.tabTextStyleActive,
                            ]}
                        >{route.name}</Text>
                    </TouchableOpacity>
                </View>)
            }
        </View>
    </>
}

export default HomeTopTabBar

const styles = StyleSheet.create({
    containerStyle: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        paddingHorizontal: 12,

        borderBottomColor: Colors.borderColor,
        borderBottomWidth: 1,
        borderStyle: 'solid'
    },
    tabStyle: {
        flex: 1,
        paddingVertical: 10,
        paddingHorizontal: 4,
    },
    tabButtonStyle: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        paddingVertical: 8,
        backgroundColor: Colors.gray[50],

        borderRadius: 20,
    },
    tabButtonStyleActive: {
        backgroundColor: Colors.primary[50],
    },
    tabTextStyle: {
        ...FontStyles.size14,
        ...FontStyles.lh22,
        ...FontStyles.dark,
        ...FontStyles.semibold,
    },
    tabTextStyleActive: {
        ...FontStyles.default
    }
})